import React, { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { IUnit } from '@/interfaces/unit';
import { addUnit, editUnit } from '@/adapters/unit';
import { useMutation } from '@tanstack/react-query';
import { IDataModal } from '@/interfaces/dataModal';

interface IProps {
  dataModal?: IDataModal<IUnit>;
  handleOk: () => void;
  handleCancel: () => void;
}

const App = ({ dataModal, handleOk, handleCancel }: IProps) => {
  const [form] = Form.useForm();
  const mutations = useMutation({
    mutationFn: async (data: IUnit) =>
      dataModal?.id ? await editUnit(data) : await addUnit(data),
    mutationKey: ['fetchUnit'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: IUnit) => {
        await mutations.mutateAsync(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (dataModal?.id) {
      form.setFieldsValue(dataModal?.item);
    }
  }, [dataModal?.id]);

  return (
    <Modal
      title={
        dataModal?.id ? `แก้ไขหน่วย ${dataModal?.item?.name}` : 'เพิ่มหน่วย'
      }
      open={dataModal?.open}
      onOk={() => handleUpdate()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="unit"
          loading={mutations.isPending}
          onClick={handleUpdate}
        >
          บันทึก
        </Button>,
      ]}
      afterClose={onReset}
    >
      <div className="flex w-full">
        <Form
          form={form}
          name="unit"
          onFinish={handleUpdate}
          layout="vertical"
          className="w-full"
        >
          <Form.Item
            label="ชื่อ"
            name="name"
            rules={[{ required: true, message: 'ระบุชื่อหน่วย' }]}
          >
            <Input size="large" disabled={!!dataModal?.id} />
          </Form.Item>
          <Form.Item
            label="ชื่อ (ไทย)"
            name="nameTH"
            rules={[{ required: true, message: 'ระบุชื่อหน่วย (ไทย)' }]}
          >
            <Input size="large" />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default App;
